import produce from 'immer';

export const addMessage = (state, payload) => {
    const newState = produce(state, draftState => {
        draftState.value = '';
    });
    return newState;
};

export const selectAnswer = (state, payload) => {
    state.msgs.push({
        image: "https://firebasestorage.googleapis.com/v0/b/playground-chatbot-529d4.appspot.com/o/src%2Fno-profile.png?alt=media&token=92ad9acd-5467-486f-92ff-089a63fdb53d",
        isMyMessage: true,
        text: payload.text
    });

    const newState = produce(state, draftState => {
        draftState.answer = (payload.isContact) ? state.answer : payload.answer;
        draftState.queston = payload.question;
        draftState.route = payload.route;
        draftState.theme = payload.theme;
    });

    if (payload.isContact) {
        return window.location.href = `https://playground.style/contact?theme=${payload.theme}&answer=${state.answer}`
    } else {
        return newState;
    }
};
